import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Image } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import NoData from 'assets/icons/NoData/noData.png';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  noDataImage?: string;
};

const styles = {
  noData: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    marginLeft: '-1rem',
    display: 'grid',
    justifyContent: 'center',
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.85,
    zIndex: 99,
  },
  overlayContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  noDataImage: {
    width: '100%',
    height: '100%',
  },
};

const NoDataOverlay: FunctionComponent<Props> = ({ noDataImage, classes }) => (
  <div className={classes.noData}>
    <Image src={noDataImage} className={classes.noDataImage} />
    <div className={classes.overlay}>
      <div className={classes.overlayContent}>
        <Image src={NoData} />
        <p>NO DATA</p>
        <p>We do not have any data to show you a graph at this time.</p>
      </div>
    </div>
  </div>
);

export default withStyles(styles)(NoDataOverlay);
